// extracted by mini-css-extract-plugin
export var adjacentSlide = "_t1-9";
export var arrowButtonContainer = "_t1-5";
export var arrowButtonIcon = "_t1-6";
export var carouselArrowButton = "_t1-2";
export var carouselElementContainer = "_t1-1";
export var currentSlide = "_t1-8";
export var left = "_t1-3";
export var otherSlide = "_t1-a";
export var productCarouselContainer = "_t1-0";
export var right = "_t1-4";
export var sliderOverflow = "_t1-7";